import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AsamcoAuthService, PageLoadingIndicatorComponent } from '@asamco/base';
import { loadStyle, pathJoin, StyleInfo } from '@asamco/utils';
import { filter, take, tap } from 'rxjs/operators';

import {
	dxDataGridDefaults,
	dxDateBoxDefaults,
	dxLookupDefaults,
	dxSelectBoxDefaults,
	dxTagBoxDefaults,
	dxTextBoxDefaults,
	registerColumnChooserSortingModule,
	registerStateStoreResetButtonModule,
} from '@asamco/devextreme';
import dxDataGrid from 'devextreme/ui/data_grid';
import dxDateBox from 'devextreme/ui/date_box';
import dxLookup from 'devextreme/ui/lookup';
import dxSelectBox from 'devextreme/ui/select_box';
import dxTagBox from 'devextreme/ui/tag_box';
import dxTextBox from 'devextreme/ui/text_box';

const styles: { [key: string]: StyleInfo } = {
	devextreme: {
		id: 'devextreme',
		href: 'devextreme.css',
		rel: 'stylesheet',
	},
	fontAwesome: {
		id: 'font-awesome',
		href: 'font-awesome.css',
		rel: 'stylesheet',
	},
};

//

@Component({
	selector: 'app-shell-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	standalone: true,
	imports: [
		RouterModule,
		PageLoadingIndicatorComponent
	]
})
export class AppComponent {
	constructor(auth: AsamcoAuthService, @Inject(DOCUMENT) document: Document) {
		document.body.style.backgroundImage = `url('${pathJoin([window['deployUrl'], '/assets/img/bg1.jpg'])}')`;

		dxDataGrid.defaultOptions({ options: dxDataGridDefaults });
		dxTextBox.defaultOptions({ options: dxTextBoxDefaults });
		dxLookup.defaultOptions({ options: dxLookupDefaults });
		dxTagBox.defaultOptions({ options: dxTagBoxDefaults });
		dxSelectBox.defaultOptions({ options: dxSelectBoxDefaults });
		dxDateBox.defaultOptions({ options: dxDateBoxDefaults });

		registerColumnChooserSortingModule();
		registerStateStoreResetButtonModule();

		auth.isLoggedIn$
			.pipe(
				filter(Boolean),
				take(1),
				tap(_ => {
					loadStyle(styles.devextreme);
					loadStyle(styles.fontAwesome);
				})
			)
			.subscribe({error: console.error});
	}
}
